const WIDGET_SOURCE_URL = 'https://mccdn.me/assets/js/widget.js'

export const getWidgetCodeLayout = (infoScriptSrc: string): string[] => {
  return [
    '<!-- Manychat -->',
    `<script src="${infoScriptSrc}" defer="defer"></script>`,
    `<script src="${WIDGET_SOURCE_URL}" defer="defer"></script>`,
  ]
}
